'use client'

import React from 'react'
import Image from 'next/image'
import { useRouter } from 'next/navigation'
import { GetImagePath } from '@/utils'
import BlogDefault1 from '@/assets/blogs/blog-2.png'

const BlogCard = ({ data, AltImage, type = 'BLOGS' }) => {
	const { push } = useRouter()

	const _imageUrl = GetImagePath(data?.image_path)

	const clickHandler = () => {
		if (data?.type === 'NEWS' || data?.type === 'MEDIA_COVERAGE') {
			if (data?.source_link.includes('http')) {
				window.open(data.source_link)
			} else if (data?.slug) {
				push(`/blogs/${data?.slug}`)
			}
		} else if (data?.slug) {
			push(`/blogs/${data?.slug}`)
		}
	}

	const getFormattedDate = (date) => {
		return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`
	}

	return (
		<div
			className='cursor-pointer'
			onClick={() => {
				clickHandler()
			}}
		>
			<div className='card bg-transparent border-0 h-100'>
				<Image
					src={_imageUrl}
					width={300}
					height={250}
					alt='Product details'
					className={`card-img-top rounded-2 ${type === 'NEWS' ? 'blog-card-img' : ''}`}
					onError={(e) => {
						e.target.src = `${BlogDefault1.src}`
					}}
				/>

				<div className='card-body rounded-3 px-0'>
					{/* <span className="blog-finance">{data?.type}</span> */}
					<p className='card-title'>{data?.title}</p>
					<div className='d-flex gap-2 align-items-center'>
						<span className='card-span'>{getFormattedDate(new Date(data?.date))}</span>
						<svg xmlns='http://www.w3.org/2000/svg' width='6' height='7' viewBox='0 0 6 7' fill='none'>
							<circle cx='3' cy='3.12207' r='3' fill='#B2B1B4'></circle>
						</svg>
						<span className='card-span'>{data?.source}</span>
					</div>
				</div>
			</div>
		</div>
	)
}

export default BlogCard
